import ChooseLocationGallery from "./ChooseLocationGallery";

class SearchLocation{

    constructor(opts){

        this.options = {
            selector: '.searchLocationFull',
            gallery: {}
        }

        Object.assign(this.options, opts);

        this.triggerUpdateName = opts.triggerUpdateName;

        this.container = $(this.options.selector);
        this.containerLoc = this.container.find('.searchLocationFull-loc');
        this.containerLocBtn = this.container.find('.searchLocationFull-locBtn');
        this.listLocations = this.container.find('.listLocations');
        this.input = this.container.find('input[name=findLocation]');

        this.icon = $('<i class="icon-location-pin"></i>');
        this.crossLocationText = $('<i class="icon-cross"></i>');
        this.containerLocBtn.prepend(this.icon);
        this.containerLocBtn.append(this.crossLocationText);

    }

    triggerUpdate(payload){
        $(document).trigger(this.triggerUpdateName, [payload])
    }

    changeInput(reloadGallery){
        let self = this;
        if(self.input.val().length > 0){
            self.containerLoc.addClass('active');
            self.crossLocationText.addClass('active');
        }else{
            self.crossLocationText.removeClass('active');

            if(reloadGallery === true){
                self.listLocations.html((new ChooseLocationGallery(self.options.gallery)).render());
            }

        }
    }

    init(firstOpenGallery){

        let self = this;

        // при инициализации, если страница загружена с локацией - отобразим галерею
        let openGallery = firstOpenGallery === true;
        if(openGallery === true){
            self.crossLocationText.addClass('active');
        }

        /**
         * В галерее что-то выбрали
         */
        $(document).on('ChooseLocationGallery.select', function(e, payload){

            self.input.val(payload ? payload.val : '');
            self.changeInput();

            if(payload){
                switch (payload.type){
                    case 'coordinates':
                        self.triggerUpdate({type: 'coordinates', coordinates: payload.coordinates});
                        break;
                    case 'country':
                        self.triggerUpdate({type: 'country', id: payload.id});
                        break;
                    case 'state':
                        self.triggerUpdate({type: 'state', id: payload.id});
                        break;
                    case 'city':
                        self.triggerUpdate({type: 'city', id: payload.id});
                        self.removeActive();
                        break;
                }
            }else{
                self.triggerUpdate({});
            }

        })

        $(document).on('focus', '.searchLocationFull-loc input[name=findLocation]', function(){
            self.addActive();
            let val = self.input.val().trim();
            if(val.length === 0 || openGallery === true){
                self.listLocations.html((new ChooseLocationGallery(self.options.gallery)).render());
                openGallery = false;
            }
        })

        $(document).on('mouseup', function(e){
            if(!self.containerLoc.is(e.target) && self.containerLoc.has(e.target).length === 0){
                self.removeActive();
            }
        });

        self.crossLocationText.on('click', () => {
            self.input.val('');
            self.removeActive();
            self.crossLocationText.removeClass('active');
            self.triggerUpdate(null);
        });

        let arrLocations         = [];
        let hoveredItem          = null;

        function hoverItem(){
            $('.listLocations .active').removeClass('active');
            arrLocations[hoveredItem].addClass('active');
        }

        function hoverDown(){
            if(arrLocations.length === 0) return;
            if(hoveredItem === null) hoveredItem = 0;
            else hoveredItem++;

            if(hoveredItem > arrLocations.length - 1) hoveredItem = 0;

            hoverItem();
        }

        function hoverUp(){
            if(arrLocations.length === 0) return;
            if(hoveredItem === null) hoveredItem = arrLocations.length - 1;
            else hoveredItem--;

            if(hoveredItem < 0) hoveredItem = arrLocations.length - 1;

            hoverItem();
        }

        function hoveredEnter(){
            if(arrLocations.length === 0) return;
            arrLocations[hoveredItem].trigger('click');
        }


        self.input.on('keyup', function(e){

            const th  = $(this);
            const val = th.val().trim();

            switch(e.keyCode){
                case 40: // down
                    hoverDown();
                    return;
                case 38: // up
                    hoverUp();
                    return;
                case 13: // enter
                    hoveredEnter();
                    return;
                case 37:
                case 39:
                    return;
            }

            self.changeInput(true);

            if(self.input.val().length > 0){
                self.listLocations.html(LoaderBox.render(true));

                self.getLocations(val).then(items => {

                    if(items.length === 0){
                        self.listLocations.html('<div class="emptyListLocation">Please enter the actual city, state or country for your search</div>');
                    }else{
                        self.listLocations.html('');
                    }

                    arrLocations = [];
                    hoveredItem = null;

                    items.forEach(item => {

                        let el = $('<div class="itemLocation"><span class="name">'+item.name+'</span></div>');

                        self.listLocations.append(el);
                        arrLocations.push(el);
                        let arrkey = arrLocations.length;

                        el.on('click', function(){

                            self.input.val(item.name);
                            hoveredItem = arrkey-1;
                            hoverItem();
                            self.removeActive();

                            const placesService = new google.maps.places.PlacesService(document.createElement('div'));
                            placesService.getDetails({ placeId: item.place_id }, function(place, status) {
                                if(status === google.maps.places.PlacesServiceStatus.OK){

                                    self.triggerUpdate({type: 'coordinates', coordinates: {
                                        lat: place.geometry.location.lat(),
                                        lng: place.geometry.location.lng()
                                    }});

                                }
                            });

                        })

                    })

                })
            }

        })


    }

    getLocations(query){

        let result = [];

        return new Promise(resolve => {

            const autocompleteService = new google.maps.places.AutocompleteService();
            autocompleteService.getPlacePredictions({ input: query, types: ['political', 'country'] }, function(predictions, status) {
                if(status === google.maps.places.PlacesServiceStatus.OK) {
                    predictions.forEach(prediction => {
                        result.push({
                            name: prediction.description,
                            place_id: prediction.place_id
                        });
                    })
                }
                resolve(result);
            });

        })

    }

    addActive(){
        let self = this;
        self.containerLoc.addClass('active');
    }

    removeActive(){
        let self = this;
        self.containerLoc.removeClass('active');
    }

}

export default SearchLocation;